import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { autobind } from 'core-decorators';
import Icon from '../../../libraries/utils/components/icon';
import { UserAvatar } from '../moderation-v2/comments-and-posts/dashboard/components';
import { User } from '../moderation-v2/users/state/types';
import Checkbox from './checkbox';
import { prettyThinNumber, toPercentage } from 'utils/pretty-number';
import EllipsisText from 'utils/components/ellipsis-text';
import { getDateString } from 'app/scripts/components/moderation-v2/sharable/utils/getDateString';

class UserFace extends Component {
  static displayName = 'UserFace';

  static propTypes = {
    className: PropTypes.string,
    userId: PropTypes.string,
    postedAt: PropTypes.any,
    onCheck: PropTypes.func,
    multiSelect: PropTypes.bool,
    checked: PropTypes.bool,
    size: PropTypes.oneOf(['extra-large', 'large', 'medium', 'normal', 'small']),
    isMessageEdited: PropTypes.bool,
    isAnonymous: PropTypes.bool,
    hasWhitelisted: PropTypes.bool,
    userDisplayName: PropTypes.string,
    messageType: PropTypes.oneOf(['comment', 'reply', 'post']),
    user: PropTypes.instanceOf(User),
    userIncivilityInfo: PropTypes.object
  };

  static defaultProps = {
    size: 'normal',
    isMessageEdited: false,
    isAnonymous: false,
    checked: false
  };

  @autobind
  onCheckChange(isChecked) {
    this.props.onCheck(isChecked);
  }

  renderMessageTypeBadge() {
    const { messageType } = this.props;

    return messageType && messageType === 'reply' ? (
      <span className="message-type-badge">
        {<Icon name="reply" className="reply-icon" />}
        {messageType.toUpperCase()}
      </span>
    ) : messageType === 'post' ? (
      <span className="message-type-badge" style={{ backgroundColor: 'dimgray' }}>
        {messageType.toUpperCase()}
      </span>
    ) : null;
  }

  renderUserIncivilityInfo() {
    const { userIncivilityInfo } = this.props;

    if (!userIncivilityInfo) {
      return null;
    }

    const { total, blocked } = userIncivilityInfo;
    const shouldDisplay = Number(total) > -1 && Number(blocked) > -1;
    const totalString = prettyThinNumber(total);
    const blockedString = prettyThinNumber(blocked);
    const percentage = toPercentage(blocked, total);

    return (
      shouldDisplay && (
        <div className={'user-incivility'}>
          <span className={'count-container'}>
            <span>Posted:</span>
            <span>{totalString}</span>
          </span>
          <span className={'count-container'}>
            <span>Rejected:</span>
            <span>{`${blockedString} ${percentage ? `(${percentage}%)` : ''}`}</span>
          </span>
        </div>
      )
    );
  }

  render() {
    var {
      postedAt,
      checked,
      multiSelect,
      isMessageEdited,
      hasWhitelisted,
      user,
      isAnonymous,
      userDisplayName
    } = this.props;

    let username = null,
      displayName = null,
      email = null;

    if (user) {
      username = user.isRegistered ? user.getUsername() : 'Guest';
      displayName = (!user.isRegistered && userDisplayName) || user.getDisplayName();
      email = user.email;
    }

    return (
      <div className="user">
        <div className="user-image-container">
          {multiSelect ? <Checkbox onChange={this.onCheckChange} checked={checked} /> : null}
          <UserAvatar user={user} />
        </div>
        <div className="user-details-container">
          {displayName ? (
            <EllipsisText className="display-name"> {displayName}</EllipsisText>
          ) : null}
          <EllipsisText className={displayName ? 'username' : 'username full'}>
            {username}
          </EllipsisText>
          {email ? <EllipsisText className="email"> {email}</EllipsisText> : null}
          {postedAt ? <span className="date">{getDateString(postedAt)}</span> : null}
          {this.renderMessageTypeBadge()}
          {isMessageEdited ? <span className="date edited">Edited</span> : null}
          {isAnonymous ? <span className="date edited">Anonymous</span> : null}
          {user?.isWhitelisted && hasWhitelisted ? (
            <span className="date whitelisted-user">Allowed User</span>
          ) : null}
          {this.renderUserIncivilityInfo()}
        </div>
      </div>
    );
  }
}

export default UserFace;
